<template>
  <div
      class="map"
      ref="map"
      id="tt_map"
      :style="map_style"
    >
  </div>
</template>

<script>
/* eslint-disable camelcase */

// const Tortoise = require('@/assets/js/cb').Tortoise
const L = require('@/assets/leaflet/leaflet-src').L
require('@/assets/cb/leaflet/leaflet.ShellLayer')
require('@/assets/cb/leaflet/leaflet.BaseLayer-GeoJson')
require('@/assets/cb/latlng-graticule/leaflet.latlng-graticule')
require('@/assets/cb/leaflet/leaflet.svgicon')
require('@/assets/cb/leaflet/leaflet-linkedtag')
require('@/assets/cb/leaflet/leaflet-cyclone')
require('@/assets/cb/leaflet/leaflet.label-carrier')
require('@/assets/cb/leaflet/leaflet.timelabel-carrier')
require('@/assets/cb/leaflet/leaflet.cyclone-radius')
require('@/assets/leaflet/track/typhoontw_leaflet')
const TcSpotHandler = require('@/assets/js/tc_spot').TcSpotHandler
const TaiwanCountyBound = require('@/assets/js/ty_county_bound').TaiwanCountyBound
const Tortoise = require('@/assets/js/cb').Tortoise

require('../../../static/new-wind-js/L.WindCanvas')
require('../../../static/new-wind-js/L.WindyLayer')

import axios from '@/axios/typhoon_tw'


import {
  MapStyle,
  MapMinZoom,
  MapMaxZoom,
  MapCenter,
  MapMaxBounds,
  GraticuleOptions,
  RateMapOption,
  TrackColorPool,
  BaseGeoJsonLayerSettings,
  TerrainBaseLayerSettings,
  SatelliteBaseLayerSettings,
  SelectAreaOption,
  WindyOptions,
  SatelliteOptions,
} from '@/components/typhoon_tw/settings'
import {
  TrackHandler
} from '@/assets/leaflet/track'
import {
  SatelliteHandler
} from '@/assets/js/satellite'
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      map: null,
      track_handler: null,
      zoom_bound_county: 7,
      map_style: {
        height: 0,
        backgroundColor: MapStyle.backgroundColor
      },
      base_layers: {
        'simple': L.baseGeoJsonLayer(BaseGeoJsonLayerSettings),
        'terrain': L.tileLayer(TerrainBaseLayerSettings.url, TerrainBaseLayerSettings),
        'satellite': L.tileLayer(SatelliteBaseLayerSettings.url, SatelliteBaseLayerSettings)
      },
      graticule_layer: L.latlngGraticule(GraticuleOptions),
      spot_handler: null,
      wind_layer: null,
      wind_proxy: null,
      satellite_handler: null,
      warning_sea: null,
      taiwan_county_bound: null,
    }
  },
  methods: {
    ...mapGetters({
      get_track_data: types.GET_TRACK_DATA,
      get_map_options: types.GET_MAP_OPTIONS,
      get_options: types.GET_OPTIONS,
      get_src_info_list: types.GET_SRC_INFO_LIST,
      get_tc_info_list: types.GET_TC_INFO_LIST,
      get_dtg: types.GET_DTG,
      get_stop_dtg: types.GET_STOP_DTG,
      get_hourly_points: types.GET_HOURLY_POINTS,
      get_wind_uri: types.GET_WIND_URI,
      get_focused_tc: types.GET_FOCUSED_TC,
      get_wind_provider: types.GET_SELECTED_WIND_SOURCE,
    }),

    ...mapActions({
      fetch_track_data: types.FETCH_TRACK_DATA,
      fetch_satellite_data: types.FETCH_SATELLITE_DATA,
      fetch_satellite_latest_time: types.FETCH_SATELLITE_LATEST_TIME,
      // fetch_wind: types.FETCH_WIND_FILE,
      reset_wind: types.RESET_WIND,
      fetch_typhoon_probability: types.FETCH_TYPHOON_PROBABILITY,
      reset_satellite_data: types.RESET_SATELLITE_DATA,
    }),

    init_map: function () {
      if (this.$refs.map) {
        this.$refs.map.style.height = window.innerHeight + 'px'

        this.map = L.map(tt_map, {
          minZoom: MapMinZoom,
          maxZoom: MapMaxZoom,
          center: MapCenter,
          maxBounds: MapMaxBounds,
          zoom: 7,
          zoomControl: false,
          continuousWorld: false,
          worldCopyJump: false,
          layers: [
            this.base_layers[this.base_layer]
          ]
        })

        // Remove Leaflet text tag
        this.map.attributionControl.setPrefix('')
        L.control.zoom({
          position: 'topleft'
        }).addTo(this.map)

        // init wind layer
        this.wind_layer = L.windyLayer(WindyOptions)
        if (this.get_options().show_wind) {
          this.map.addLayer(this.wind_layer);
        }

        // xstep initialize
        this.satellite_handler = new SatelliteHandler(this.map, SatelliteOptions, this.show_satellite)

        // init warning sea boundary
        this.warning_sea_layer = new L.GeoJsonLayer({
            style: {
                color: 'rgb(170, 170, 170)',
                weight: 1,
                opacity: 0.7
            },
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/taiwan_TyphoonWarning_Sea.json'
        })

        // init taiwan conuty boundary
        this.taiwan_county_bound = new TaiwanCountyBound('/' + process.env.ASSETS_SUB_DIR + '/data/taiwan_county.json')

        if (this.map.getZoom() >= this.zoom_bound_county) {
          this.map.addLayer(this.warning_sea_layer)
          this.taiwan_county_bound.show(this.map)
        }

        this.map.on('zoomend', () => {
          var currZoom = this.map.getZoom()
          if (currZoom >= this.zoom_bound_county) {
            this.map.addLayer(this.warning_sea_layer)
            this.taiwan_county_bound.show(this.map)
          }
          else {
            this.map.removeLayer(this.warning_sea_layer)
            this.taiwan_county_bound.hide(this.map)
          }
        })
      }
    },

    set_base_layer: function (base_layer_key) {
      for (let layer_key in this.base_layers) {
        if (layer_key === base_layer_key) {
          this.map.addLayer(this.base_layers[layer_key])
        } else {
          this.map.removeLayer(this.base_layers[layer_key])
        }
      }
    },
    toggle_graticule_layer: function (toggle) {
      if (toggle) {
        this.map.addLayer(this.graticule_layer)
      } else {
        this.map.removeLayer(this.graticule_layer)
      }
    },

    fetch_wind() {
      let _stop_dtg = this.get_stop_dtg()
      if (!_stop_dtg) { return }
      let provider = this.get_wind_provider()
      return new Promise((resolve, reject) => {
        const url = provider === 'weathernext'
          ? '/wind/weathernext/'
          : '/wind/' + provider + '/gfs/'
        axios.get(url, {
          params: {
            dtg: _stop_dtg,
            // mode: 'bin'
          }
        })
        .then(response => {
          return response.data
        })
        .then(data => {
          if (data &&
              data.type &&
              data.type === 'Coverage') {
            this.wind_layer.setData(data)
          }
          else {
            this.wind_layer.setData(null)
          }
        })
        .catch(error => {
          reject(error)
        })
      })
    }

  },

  computed: {
    ...mapGetters({
      get_typhoon_probability: types.GET_TYPHOON_PROBABILITY,
      get_satellite_latest_time: types.GET_SATELLITE_LATEST_TIME
    }),

    track_data () {
      return {
        tc_infos: this.get_tc_info_list(),
        src_infos: this.get_src_info_list(),
        track: this.get_track_data()
      }
    },

    src_info_list () {
      return this.get_src_info_list()
    },

    tc_info_list () {
      return this.get_tc_info_list()
    },

    base_layer () {
      return this.get_map_options().base_layer
    },

    map_view () {
      let _map_options = this.get_map_options()
      return {
        center: _map_options.center,
        zoom: _map_options.zoom
      }
    },

    selected_init_time_z () {
      return this.get_options().selected_init_time_z
    },

    track_options () {
      let _options = this.get_options()
      return {
        selected_src: _options.selected_src,
        selected_tc: _options.selected_tc,
        selected_init_time_z: _options.selected_init_time_z,
        show_timelabel: _options.show_timelabel,
        show_src_name: _options.show_src_name,
        show_spotlight: _options.show_spotlight
      }
    },

    show_graticule () {
      return this.get_options().show_graticule
    },

    show_typhoon_probability () {
      return this.get_options().show_typhoon_probability
    },

    show_probability_chart () {
      return this.get_options().show_probability_chart
    },

    show_spotlight () {
      return this.get_options().show_spotlight
    },

    selected_src () {
      return this.get_options().selected_src
    },

    selected_tc () {
      return this.get_options().selected_tc
    },

    show_satellite () {
      return this.get_options().show_satellite
    },

    selected_satellite_data () {
      return this.get_options().selected_satellite_data
    },

    show_wind () {
      return this.get_options().show_wind
    },

    selected_wind_src () {
      return this.get_options().selected_wind_src
    },

    dtg () {
      let _dtg = this.get_dtg()
      return _dtg
    },

    stop_dtg () {
      let _stop_dtg = this.get_stop_dtg()
      return _stop_dtg
    },

    hourly_points() {
      let _data = this.get_hourly_points();
      return _data.map(track => [
        track.init_time_z, track.src, track.tc_name
      ]);
    },

    selected_wind_uri() {
      return this.get_wind_uri();
    },

    tc_focus () {
      let focused_tc = this.get_focused_tc()
      return focused_tc.trigger
    }

  },

  mounted () {
    this.init_map()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.map_style.height = window.innerHeight + 'px'
      })
    })
    this.track_handler = new TrackHandler(this, {})

    this.spot_handler = new TcSpotHandler(this.map,
        this.get_options().show_spotlight)

    this.fetch_satellite_latest_time()
  },

  watch: {
    track_data() {
      this.track_handler.options = this.track_options
      this.track_handler.data = this.track_data
      this.track_handler.initTimeLabel()
      this.track_handler.refreshTracks()
    },

    track_options() {
      this.track_handler.options = this.track_options
      this.track_handler.refreshTracks()
    },

    selected_init_time_z (init_time_z) {
      this.fetch_track_data()
      this.taiwan_county_bound.set_init_time_z(init_time_z)
      let self = this
      if (!self.tortoise_probability) {
        let _ = () => {
          self.fetch_typhoon_probability()
        }
        self.tortoise_probability = new Tortoise(_, {
          delay: 5000
        })
      }
      self.tortoise_probability.punch()
    },

    base_layer () {
      this.set_base_layer(this.base_layer)
    },

    show_graticule () {
      this.toggle_graticule_layer(this.show_graticule)
    },

    show_typhoon_probability () {
      this.taiwan_county_bound.set_visible(this.show_typhoon_probability)
    },

    show_probability_chart () {
      // todo:縣市放假機率圖
    },

    get_typhoon_probability: {
      handler(new_data, old_data) {
        this.taiwan_county_bound.set_data(new_data)
      },
      deep: true
    },

    get_satellite_latest_time: {
      handler(new_date, old_date) {
        if (this.get_options().show_satellite) {
          if (new_date !== old_date) {
            this.fetch_satellite_data()
          }
        }
      },
      deep: true
    },

    dtg () {
      let _dtg = this.get_dtg();
      this.spot_handler.set_dtg(_dtg);
      this.taiwan_county_bound.set_tau(_dtg)
      this.taiwan_county_bound.set_probability_visible()
      this.fetch_satellite_latest_time()
    },

    stop_dtg () {
      if (this.get_options().show_wind) {
        this.fetch_wind()
      }
    },

    src_info_list () {
      let srcs = this.get_src_info_list();
      this.spot_handler.set_srcs(srcs);
    },

    tc_info_list () {
      let tc_infos = this.get_tc_info_list();
      this.spot_handler.set_tc_infos(tc_infos);
    },

    hourly_points() {
      this.spot_handler.set_tracks(this.get_hourly_points());
    },

    show_spotlight() {
      this.spot_handler.set_visible(this.get_options().show_spotlight);
    },

    selected_src () {
      let selected_srcs = this.get_options().selected_src;
      this.spot_handler.set_src_visible(selected_srcs);
    },

    selected_tc () {
      let selected_tcs = this.get_options().selected_tc;
      this.spot_handler.set_tc_visible(selected_tcs);
    },

    selected_wind_uri() {
      let uri = this.get_wind_uri();
      if (this.wind_proxy) {
        this.wind_proxy.goto_dtg(uri);
      }
    },

    show_wind: {
      handler(visible) {
        if (this.wind_layer && this.map) {
          if (this.get_options().show_wind) {
            this.map.addLayer(this.wind_layer);
          }
          else {
            // this.reset_wind();
            this.map.removeLayer(this.wind_layer);
          }
        }
      }
    },

    selected_wind_src() {
      this.fetch_wind();
    },

    tc_focus () {
      let focused_tc_name = this.get_focused_tc().name
      let max_layer_bound = null

      for (let layer_num in this.track_handler._fcstTracks) {
        let layer = this.track_handler._fcstTracks[layer_num]

        if (layer._tc_info.name !== focused_tc_name) {
          continue
        }

        let _layer_bound = layer.getBounds()

        if (max_layer_bound == null) {
          max_layer_bound = _layer_bound
          continue
        }

        // compare bounds, get largest bound
        if (_layer_bound.getNorthEast().lat > max_layer_bound.getNorthEast().lat) {
          max_layer_bound._northEast.lat = _layer_bound.getNorthEast().lat
        }
        if (_layer_bound.getNorthEast().lng > max_layer_bound.getNorthEast().lng) {
          max_layer_bound._northEast.lng = _layer_bound.getNorthEast().lng
        }
        if (_layer_bound.getSouthWest().lat < max_layer_bound.getSouthWest().lat) {
          max_layer_bound._southWest.lat = _layer_bound.getSouthWest().lat
        }
        if (_layer_bound.getSouthWest().lng < max_layer_bound.getSouthWest().lng) {
          max_layer_bound._southWest.lng = _layer_bound.getSouthWest().lng
        }
      }

      this.map.fitBounds(max_layer_bound)
    },

    // xstep 6
    show_satellite() {
      if (this.get_options().show_satellite) {
        this.satellite_handler.set_visible(this.show_satellite);
        this.fetch_satellite_data();
      }
      else {
        this.satellite_handler.set_visible(this.show_satellite);
        this.reset_satellite_data();
      }
    },

    // xstep 10
    selected_satellite_data: {
      handler(new_data, old_data) {
        if (new_data) {
          this.satellite_handler.update(this.selected_satellite_data);
        } else {
          this.satellite_handler.remove_layer()
        }
      },
      deep: true
    }
  }
}
</script>

<style>
@import "../../assets/leaflet/leaflet.css";
@import "../../assets/cb/leaflet/leaflet-linkedtag.css";

</style>



// WEBPACK FOOTER //
// src/components/typhoon_tw/Map.vue